import { ReassignAllDepotsDialog } from "./components/ReassignAllDepotsDialog";

export default ReassignAllDepotsDialog;